/**
 * Transfer 타입 정의 (본사 -> 협력사 송금)
 */

/** 송금 내역 Domain Model */
export type TransferHistory = {
    seqNo: number;
    processDate: string;
    suppId: string;
    suppName: string;
    transferAmt: number;
    headBalanceAfter: number;
    suppBalanceAfter: number;
    briefs: string;
    insUser: string;
};

/** 송금 내역 DTO (백엔드 응답) */
export type TransferHistoryDto = {
    seqNo: number;
    processDate: string;
    suppId: string;
    suppName: string;
    transferAmt: number;
    headBalanceAfter: number;
    suppBalanceAfter: number;
    briefs: string;
    insUser: string;
};

/** 송금 내역 목록 조회 응답 DTO */
export type GetTransferListResponseDto = {
    list: TransferHistoryDto[];
    totalCount: number;
    totalTransferAmt: number;
};

/** 송금 신청 요청 DTO */
export type PostTransferRequestDto = {
    suppId: string;
    reqVal: number;
    briefs?: string;
    insertUserId?: string;
};

/** 송금 신청 응답 DTO */
export type PostTransferResponseDto = {
    success: boolean;
    message: string;
    transferSeqNo?: number;
    headBalanceAfter?: number;
    suppBalanceAfter?: number;
};

/** 협력사 옵션 DTO */
export type SupplierOptionDto = {
    suppId: string;
    suppName: string;
};

/** 검색 필터 타입 */
export type TransferFilters = {
    startDate: string;
    endDate: string;
    suppId: string;
};

/** TransferModal Props */
export type TransferModalProps = {
    supplierOptions: SupplierOptionDto[];
    onClose: () => void;
    onRequest: (suppId: string, amount: number, memo?: string) => Promise<void>;
};

/** DTO -> Domain 변환 */
export const transferHistoryFromDto = (dto: TransferHistoryDto): TransferHistory => {
    return {
        seqNo: dto.seqNo,
        processDate: dto.processDate || '',
        suppId: dto.suppId || '',
        suppName: dto.suppName || '',
        transferAmt: dto.transferAmt || 0,
        headBalanceAfter: dto.headBalanceAfter || 0,
        suppBalanceAfter: dto.suppBalanceAfter || 0,
        briefs: dto.briefs || '',
        insUser: dto.insUser || ''
    };
};

/** 목록 변환 */
export const transferHistoryListFromDto = (
    response: GetTransferListResponseDto
): TransferHistory[] => {
    if (!response || !response.list || !Array.isArray(response.list)) {
        return [];
    }
    return response.list.map(transferHistoryFromDto);
};

/** 기본 필터 생성 */
export const createDefaultTransferFilters = (): TransferFilters => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        startDate: formatDate(startOfMonth),
        endDate: formatDate(today),
        suppId: ''
    };
};
